@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../respond-to.scss';
@import '../../global-styles/index.scss';

// override bad stlying from Catalog; TODO: remove this from Catalog after test
ci-header {
  min-height: unset !important;
}
@media only screen and (min-width: 1024px) {
  .ciHeader-main {
    ci-navigation-rightside {
      display: none;
    }
  }
  ci-mobile-subnav {
    display: none;
  }
}

.ciHeader {
  position: relative;
  z-index: 100;
  display: flex;
  flex-direction: column;

  // This CSS is just for SB apps, otherwise the button looks funny due to missing font.
  .ghf-text-button,
  .ghf-primary-button,
  .ghf-secondary-button {
    font-family: SharpSans, Sharp Sans, Helvetica, Arial, 'Trebuchet MS', sans-serif;
  }

  &-banner {
    background-color: $color-red-default;
    z-index: 980;
    height: $spacing-32;
    &-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 $spacing-16;
      gap: $spacing-16;
      background-color: $color-red-default;
      font-size: $typography-caption-caption-regular-size;
      color: $color-shade-white;
      justify-content: space-between;
      box-sizing: content-box;
      height: inherit;
    }
    &-title {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    &-actions {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      padding: 0;
      gap: $spacing-16;
      height: 100%;
      margin-right: -16px;
      @media (max-width: 1023px) {
        margin-right: 0;
      }
    }
    &-title--desktop {
      display: none;
    }
    @media only screen and (min-width: 1024px) {
      customer-chat,
      customer-contact {
        display: none;
      }
    }
  }
  &-main {
    display: flex;
    border-bottom: 1px solid $color-gray-accent;
    background-color: $color-shade-white;
    height: $spacing-48;
    &--withSearch {
      @extend .ciHeader-main;

      .ci-drawer-window {
        top: 88px;
      }

      .ci-drawer-menu {
        height: calc(100vh - 86px);
      }
    }
    &-wrapper {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      align-items: center;
      height: 100%;
      width: 100%;
      box-sizing: content-box;
      gap: 4px;
      @media only screen and (min-width: 700px) {
        gap: $spacing-32;
      }
    }
  }
  &-navigation {
    z-index: 910;
    position: relative;
    display: none;
    border-bottom: 1px solid $color-gray-accent;
    background-color: $color-shade-white;
    height: 51px;
    box-sizing: border-box;
    .ciHeader-subNav-text {
      @media (min-width: 1024px) {
        padding: 12px 16px;
      }
    }
  }
  &-overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 900;
    left: 0;
    background-color: rgba(0, 0, 0, 0.4);
    visibility: hidden;
    opacity: 0;
    transition: all 0.15s ease-out;
    &.active {
      visibility: visible;
      opacity: 1;
    }
  }
  &-subNav {
    display: flex;
    flex-direction: row;
  }
  &-mobile-menu-btn {
    cursor: pointer;
    align-self: center;
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding: 14px 11px;
    margin-left: -8px;
    margin-right: 4px;
    span {
      background: black;
      border-radius: 3px;
      content: '';
      width: 18px;
      height: 2px;
    }
  }
  &-logo {
    &-image {
      height: 40px;
      display: block;
    }
  }
}

// simple customer support
.ciHeader-CustomerSupport {
  display: flex;
  gap: 16px;
  flex-shrink: 0;

  &-divider {
    @media only screen and (max-width: 699px) {
      display: none;
    }
    border: 0.5px solid $color-gray-accent;
    margin: 3px 0;
  }
}

// TTARP mobile in red bar
.ciHeader-banner-ttarpMobile {
  display: flex;
  height: 100%;
  cursor: pointer;
  text-decoration: none;
  color: $color-shade-white;
  &:link,
  &:visited,
  &:hover {
    color: $color-shade-white;
  }
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  @include breakpoint('lg') {
    display: none;
  }
  @include breakpoint('xl') {
    display: none;
  }
}

@include breakpoint('lg') {
  .ciHeader {
    &-banner {
      &-wrapper {
        padding: 0 24px;
        max-width: 978px;
        margin: auto;
      }
      &-title {
        &--desktop {
          display: inline;
        }
      }
      &-actions {
        margin: 0;
      }
      &-title--mobile {
        display: none;
      }
    }
    &-main {
      height: 63px;
      z-index: 910;
      &-wrapper {
        align-items: center;
        max-width: 976px;
        margin: auto;
        justify-content: space-between;
        padding: 4px 0px;
        box-sizing: border-box;
      }
      &-image {
        &--mobile {
          display: none;
        }
        &--desktop {
          display: block;
          height: 50px;
        }
      }
    }
    &-logo-image {
      height: 48px;
    }
    &-subNav {
      gap: $spacing-16;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    &-hamburger-button,
    &-products-menu,
    &-mobile-menu-btn,
    &-mobile-nav {
      display: none;
    }
    &-navigation {
      display: flex;
    }
  }
}

@include breakpoint('xl') {
  .ciHeader {
    margin: auto;
    &-banner {
      &-wrapper {
        padding: 0 24px;
        max-width: 1252px;
        margin: auto;
      }
      &-title {
        &--desktop {
          display: inline;
        }
      }
      &-actions {
        margin: 0;
      }
      &-actions--desktop {
        display: flex;
        min-width: 526px;
      }
      &-title--mobile,
      &-actions--mobile {
        display: none;
      }
    }
    &-main {
      height: 63px;
      z-index: 910;
      &-wrapper {
        align-items: center;
        max-width: 1252px;
        margin: auto;
        justify-content: space-between;
        padding: 4px 0px;
        box-sizing: border-box;
      }
      &-image {
        &--mobile {
          display: none;
        }
        &--desktop {
          display: block;
          height: 50px;
        }
      }
    }
    &-logo-image {
      height: 48px;
    }
    &-subNav {
      gap: $spacing-16;
      height: 80px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    &-hamburger-button,
    &-products-menu,
    &-mobile-menu-btn,
    &-mobile-nav {
      display: none;
    }
    &-navigation {
      display: flex;
    }
  }
}
@media only screen and (min-width: 1024px) {
  .ciHeader-subNav {
    height: 100%;
  }
}
@media only screen and (max-width: 1023px) {
  .ciHeader-CustomerSupport {
    display: none;
  }
  .ciHeader-main {
    height: 63px;
  }
  .ciHeader-main-wrapper {
    padding: 0 $spacing-16;
  }
}

@media only screen and (max-width: 699px) {
  .ciHeader-main {
    &--withSearch {
      @extend .ciHeader-main;
      height: 104px;

      .ciHeader-main-wrapper {
        height: 56px;
      }
    }
  }
}
